module.exports = __webpack_public_path__ + "static/media/new-york-43.d42a109e.jpg";